import { useNotificationSocket } from '@sit/notifications-client';
import { NotificationPayload } from '@sit/notifications-shared';
import { queryKeyFn } from '@sit/openapi';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useState } from 'react';

export function useLatestServerNotification() {
  const [notifications, setNotifications] = useState<NotificationPayload[]>([]);
  const queryClient = useQueryClient();
  const notificationSocket = useNotificationSocket();

  const acknowledgeNotification = useCallback(() => {
    setNotifications((pendingNotifications) => pendingNotifications.slice(1));
  }, []);

  useEffect(() => {
    const cleanupNotif = notificationSocket.onNotification((notification) => {
      setNotifications((pendingNotifications) => [...pendingNotifications, notification]);
    });

    // Invalidate on reconnect to ensure no missed messages
    const cleanupReconnect = notificationSocket.onReconnect(() => {
      void queryClient.invalidateQueries({
        queryKey: queryKeyFn({
          path: '/notifications',
          operationId: 'getApiNotifications',
          variables: {},
        }),
      });
    });

    return () => {
      cleanupNotif();
      cleanupReconnect();
    };
  }, [queryClient, notificationSocket]);

  const notification = notifications[0];

  return {
    data: notification ? { newNotification: notification } : undefined,
    acknowledgeNotification,
    loading: false,
    error: undefined,
  };
}
